import { Link } from "react-router-dom";
import { MOVE_LABELS, FIELD_LABELS, eurOr } from "@/lib/wh";

const show = (v) => (v == null || v === "" ? "—" : Array.isArray(v) ? `${v.length} foto` : String(v));

export function MovementList({ rows, showItem }) {
  return (
    <ul className="rounded-2xl bg-white border border-[var(--border)] px-4 divide-y divide-[var(--border)]" data-testid="wh-movements">
      {rows.map((m, i) => (
        <li key={`${m.at}-${i}`} className="py-3 text-sm grid sm:grid-cols-[140px_120px_1fr] gap-1 sm:gap-3" data-testid="wh-movement-row">
          <span className="text-[var(--muted)] tabular-nums">{new Date(m.at).toLocaleString("it-IT")}</span>
          <span className="font-semibold">{MOVE_LABELS[m.type] || m.type}</span>
          <span className="min-w-0 break-words">
            {showItem && (m.type === "eliminazione" ? <span className="font-mono mr-1">{m.item_code}</span>
              : <Link to={`/magazzino/articoli/${m.item_id}`} className="font-mono underline mr-1">{m.item_code}</Link>)}
            {m.detail}{m.amount != null && m.type !== "vendita" ? ` · ${eurOr(m.amount)}` : ""}
            <span className="block text-xs text-[var(--muted)]">{m.user_name}{m.lot_name ? ` · ${m.lot_name}` : ""}</span>
            {m.changes?.map((c) => <span key={c.field} className="block text-xs">{FIELD_LABELS[c.field] || c.field}: <s className="text-[var(--muted)]">{show(c.old)}</s> → <b>{show(c.new)}</b></span>)}
          </span>
        </li>
      ))}
      {!rows.length && <li className="py-8 text-center text-[var(--muted)]">Nessun movimento</li>}
    </ul>
  );
}
